import { Car } from '@/types/car.type.ts';

export function getCarDealerFullName(car: Car): string {
    return `${car.dealer.dealer_name} [${car.dealer.city_name}]`;
}
